<div style="page-break-inside: avoid;" *ngIf="returnData?.headSummery?.csrSummary?.csrList?.length > 0" class="mt-4"
     [ngClass]="{'container': !isSinglePageReturn, 'return-view-background-print': !isSinglePageReturn && printActive, 'return-view-background': !isSinglePageReturn && !printActive}">
  <div class="row mb-5">
    <div class="col-12 text-center" style="font-size:16px">
      <b>
        Donation(6th Schedule)
      </b>
      <br/>
      <em>[Attachment for Donation under 6th Schedule Part 2]</em>
    </div>
  </div>

  <div class="row">
    <div class="col-sm-6">Taxpayer Name: {{ returnData?.profileData?.assesName }}</div>
    <div class="col-sm-6 text-right">
      Assessment Year: {{ returnData?.submissionInfo?.assessmentYear }}
    </div>
  </div>
  <div class="row mt-3 mb-5">
    <div class="col-sm-6">
      TIN
      <span class="ml-3" style="white-space: nowrap;">
                <input value="{{item}}" *ngFor="let item of returnData?.profileData?.tin.split('')"
                       class="input-default" disabled/>
            </span>
    </div>
    <div class="col-sm-6 text-right">
      Total Donation Amount: <b>{{ (returnData?.taxPaymentData?.poti_CSR_Donation_Amt_PMEAT + returnData?.taxPaymentData?.poti_CSR_Donation_Amt_Except_PMEAT) | currencySeparatorBD }}</b>
      <br/>
      Total Allowable Donation: <b>{{ returnData?.taxPaymentData?.poti_TOTAL_Allowable_CSR_Donation_Amt | currencySeparatorBD }}</b>
    </div>
  </div>

  <div style="page-break-inside: avoid" class="row mb-5"
       *ngIf="returnData?.headSummery?.csrSummary?.csrList?.length > 0">
    <div class="col-12 text-center mb-2 font-weight-bold">
      Donation Details
    </div>
    <div class="col-12">
      <table class="table table-bordered csr-details-table">
        <tbody>
        <tr class="font-weight-bold">
          <td class="text-center">Donation Category</td>
          <td class="text-center">Fund Name</td>
          <td class="text-center">Receiver Account Number</td>
          <td class="text-center">Bank Name</td>
          <td class="text-center">Receipt No</td>
          <td class="text-center">Receipt Date</td>
          <td class="text-center">Assessee Account Number</td>
          <td class="text-center">Bank Name</td>
          <td class="text-center">Donation Amount</td>
        </tr>
        <tr *ngFor="let item of returnData?.headSummery?.csrSummary?.csrList">
          <td>{{ item.donationCategoryLabel }}</td>
          <td>{{ item.fundName }}</td>
          <td>{{ item.receiverBankAc }}</td>
          <td>{{ item.receiverBankName || getBankName(item.receiverBankId) }}</td>
          <td>{{ item.receiptNumber }}</td>
          <td>{{ item.receiptDate }}</td>
          <td>{{ item.assesseeBankAc }}</td>
          <td>{{ item.assesseeBankName || getBankName(item.assesseeBankId) }}</td>
          <td class="text-right">{{ item.csrDonationAmount | currencySeparatorBD }}</td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>

</div>
